import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Users, Award, TrendingUp } from 'lucide-react';

export default function HomePage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 to-indigo-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">เรียนรู้ได้ทุกที่ ทุกเวลา</h1>
          <p className="text-xl mb-8 text-blue-100">แพลตฟอร์มการเรียนรู้ออนไลน์ที่ครบครัน สำหรับทุกคน</p>
          <div className="flex gap-4 justify-center">
            <Link to="/courses" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition">
              ดูคอร์สทั้งหมด
            </Link>
            <Link to="/register" className="bg-blue-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-400 transition">
              เริ่มต้นเรียนฟรี
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <FeatureCard icon={<BookOpen size={40} />} title="คอร์สคุณภาพ" desc="เรียนรู้จากเนื้อหาที่จัดทำโดยผู้เชี่ยวชาญ" />
            <FeatureCard icon={<Users size={40} />} title="ชุมชน" desc="แลกเปลี่ยนความรู้กับผู้เรียนนับพันคน" />
            <FeatureCard icon={<Award size={40} />} title="ใบรับรอง" desc="รับใบรับรองเมื่อจบคอร์ส" />
            <FeatureCard icon={<TrendingUp size={40} />} title="ติดตามความคืบหน้า" desc="ดูสถิติการเรียนของคุณ" />
          </div>
        </div>
      </section>
    </div>
  );
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div className="text-center p-6 rounded-xl bg-gray-50 hover:bg-blue-50 transition">
      <div className="text-blue-600 mb-4 flex justify-center">{icon}</div>
      <h3 className="font-bold text-lg mb-2">{title}</h3>
      <p className="text-gray-600">{desc}</p>
    </div>
  );
}
